import React from "react";
import InquiryToCustomer from "../../../types/Entities/InquiryToCustomer";
import { Box, Stack, Typography } from "@mui/material";
import { minStringLength, requiredValidator } from "../../../services/validationRules";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import InquiryToCustomerMediaObjects from "./InquiryToCustomerMediaObjects";

type InquiryToCustomerInformationBoxProps = {
  inquiryToCustomer: InquiryToCustomer;
};

export default function InquiryToCustomerInformationBox({ inquiryToCustomer }: InquiryToCustomerInformationBoxProps) {
  const errorTextInquiryTextInformationCustomer =
    "Bitte teilen Sie uns die benötigten Informationen mit. Wenn Sie die Informationen nicht (vollständig) haben, dann schreiben Sie dies bitte hier kurz.";

  return (
    <Box>
      <Typography variant={"cardTitle"} component={"h2"}>
        Benötigte Informationen
      </Typography>
      {!!inquiryToCustomer.inquiryTextInformation && (
        <>
          <Typography variant={"body2"} sx={{ marginTop: "1.5rem" }}>
            <strong>Folgende Informationen benötigen wir von Ihnen:</strong>
          </Typography>
          <Typography variant={"body2"} sx={{ margin: "1rem 0 1.5rem" }} dangerouslySetInnerHTML={{ __html: inquiryToCustomer.inquiryTextInformation }} />
          <Box sx={{ marginBottom: "1.5rem" }}>
            <InquiryToCustomerMediaObjects inquiryToCustomer={inquiryToCustomer} />
          </Box>
        </>
      )}
      <ValidatorTextField
        label="Ihre Antwort"
        name="inquiryTextInformationCustomer"
        multiline
        InputLabelProps={{
          shrink: true,
        }}
        rows={5}
        validators={[
          requiredValidator(errorTextInquiryTextInformationCustomer),
          {
            validator: minStringLength,
            params: [10],
            message: errorTextInquiryTextInformationCustomer,
          },
        ]}
      />
    </Box>
  );
}
